import { ErrorUtils } from 'bitmovin-player-ui';
export const customSpecificErrorMessageOverlayConfig = {
    1000: 'Oeps, er gaat iets mis',
    1001: 'Oeps, er gaat iets mis',
    1101: 'De player is niet aangemaakt',
    1102: 'Er ging iets mis met de configuratie',
    1103: 'Er is iets mis met de licentie (access key)',
    1104: 'De video kan niet worden afgespeeld op dit domein',
    1105: 'De video kan niet op dit web-adres worden afgespeeld',
    1106: '',
    1107: '',
    1108: '',
    1113: 'De video kan niet worden afgespeeld zonder web server',
    1201: 'Er is iets mis met de source configuratie',
    1202: (error) => {
        return ErrorUtils.defaultErrorMessages[error.code];
    },
    1203: 'Helaas, deze video is niet beschikbaar.',
    1204: '',
    1205: '',
    1206: '',
    1207: '',
    1208: (error) => {
        const statusCode = error.data.statusCode;
        return 'Manifest laden mislukt met HTTP fout ' + statusCode;
    },
    1209: '',
    1210: '',
    1211: '',
    1301: '',
    1304: '',
    1400: 'Er is iets mis met uw internet-verbinding',
    1401: '',
    1402: '',
    1403: '',
    1404: '',
    2001: '',
    2002: '',
    2003: 'Oeps, er is iets mis met het opvragen van de DRM',
    2005: '',
    2006: 'Oeps, er is iets mis met de DRM',
    2007: '',
    2008: '',
    2009: '',
    2010: '',
    2011: '',
    2012: '',
    2013: '',
    2015: '',
    2101: '',
    3001: '',
    3002: '',
    3003: '',
    3004: '',
    4000: ''
};
